/** Path builders for the app's routes (the URLs are part of the contract: e-mails link to them). */
export const routes = {
  fau: (token: string) => `/fau/${encodeURIComponent(token)}`,
  home: () => "/",
  login: (next?: string) => (next ? `/logg-inn?neste=${encodeURIComponent(next)}` : "/logg-inn"),
  forgotPassword: () => "/glemt-passord",
  kommuner: () => "/kommuner",
  kommunePublic: (nr: string) => `/kommuner/${encodeURIComponent(nr)}`,
  contact: (kommunenummer?: string) =>
    kommunenummer ? `/kontakt?kommune=${encodeURIComponent(kommunenummer)}` : "/kontakt",
  privacy: () => "/personvern",
  dpa: () => "/databehandling",
  admin: () => "/admin",
  members: (orgId: string) => `/o/${orgId}/medlemmer`,
  dashboard: (orgId: string, nr: string) => `/o/${orgId}/k/${nr}`,
  school: (orgId: string, nr: string, schoolId: string, findingKey?: string) =>
    `/o/${orgId}/k/${nr}/skoler/${encodeURIComponent(schoolId)}` +
    (findingKey ? `?funn=${encodeURIComponent(findingKey)}` : ""),
  tiltak: (orgId: string, nr: string, params?: Record<string, string>) => {
    const qs = params ? new URLSearchParams(params).toString() : "";
    return `/o/${orgId}/k/${nr}/tiltak${qs ? `?${qs}` : ""}`;
  },
  changes: (orgId: string, nr: string) => `/o/${orgId}/k/${nr}/endringer`,
  change: (orgId: string, nr: string, changeId: string) =>
    `/o/${orgId}/k/${nr}/endringer/${changeId}`,
  exports: (orgId: string, nr: string) => `/o/${orgId}/k/${nr}/eksport`,
  fauAdmin: (orgId: string, nr: string) => `/o/${orgId}/k/${nr}/fau`,
};

/** Only allow same-site relative redirects after login (no `//evil.example`). */
export function safeNext(next: string | null): string {
  if (next && next.startsWith("/") && !next.startsWith("//") && !next.startsWith("/\\")) {
    return next;
  }
  return "/";
}
